export default "__VITE_ASSET__CwtGTrIJ__"